import axiosInstance from '../../../axiosInstance2'
import apiEndpoints from '../../../api'
import { notify } from '../../../../utils/notification'

/* =========================
   LIST COMMUNITIES
========================= */
export const getBrandListReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
        search: searchQuery.search || '',
        status: searchQuery?.status,
        type: searchQuery?.type,

    };

    return axiosInstance.get(apiEndpoints.CTRL_BRAND_LIST_API, {
        params
    })
        .then(response => response)
        .catch(errors => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};


/* =========================
   CREATE COMMUNITY
========================= */
export const createBrandReq = (action) => {
    const body = {
        name: action?.data?.brandName,
        logo_url: action?.data?.logo_url,
        description: action?.data?.description,
        website: action?.data?.website,
    };

    return axiosInstance.post(apiEndpoints.CTRL_CREATE_BRAND_API, { ...body })
        .then(response => response)
        .catch(errors => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};


/* =========================
   GET COMMUNITY DETAILS
========================= */
export const getBrandDetailsReq = (action) => {
    return axiosInstance.get(
        `${apiEndpoints.CTRL_GET_BRAND_API}/${action?.data?.id}`
    )
        .then(response => response)
        .catch(errors => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};


/* =========================
   UPDATE COMMUNITY
========================= */
export const editBrandReq = (action) => {
    const body = {
        name: action?.data?.brandName,
        logo_url: action?.data?.logo_url,
        description: action?.data?.description,
        website: action?.data?.website,
    };

    return axiosInstance.put(
        `${apiEndpoints.CTRL_EDIT_BRAND_API}/${action?.data?.id}`,
        { ...body }
    )
        .then(response => response)
        .catch(errors => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};


/* =========================
   DELETE COMMUNITY
========================= */
export const deleteBrandReq = (action) => {
    return axiosInstance.delete(
        `${apiEndpoints.CTRL_GET_BRAND_API}/${action?.data?.id}`
    )
        .then(response => response)
        .catch(errors => {
            console.log("errors", errors);
            if (errors.response?.data?.statusCode === 400 || errors.response?.data?.statusCode === 404) {
                notify('error', errors.response?.data?.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors;
        });
};
